import { render, staticRenderFns } from "./PortForwardingForm.vue?vue&type=template&id=b60bc472&"
import script from "./PortForwardingForm.vue?vue&type=script&lang=js&"
export * from "./PortForwardingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports